import { Star, Quote as QuoteIcon } from "lucide-react";
import Reveal from "./Reveal";
import { TESTIMONIALS } from "../data/site";

const Stars = () => (
  <div className="flex gap-0.5">{[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />)}</div>
);

export const Reviews = () => (
  <section id="referenser" className="bg-brand-iceBg scroll-mt-24" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
      <div className="max-w-2xl">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-blue">Referenser</p>
        </Reveal>
        <Reveal delay={0.06}>
          <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-brand-ink leading-tight">
            Kunder som ser klart ut igen
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">
            Vi är stolta över förtroendet från privatpersoner och företag i hela Skaraborg.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Featured review */}
        <Reveal className="lg:col-span-7">
          <figure className="h-full rounded-3xl bg-brand-ink text-white p-8 md:p-10 relative overflow-hidden flex flex-col" data-testid="review-featured">
            <div className="absolute -right-14 -top-14 h-44 w-44 rounded-full bg-brand-blue/25 blur-3xl" aria-hidden="true" />
            <QuoteIcon className="h-9 w-9 text-brand-blue/60" />
            <blockquote className="relative mt-6 font-heading text-2xl md:text-3xl font-semibold leading-snug tracking-tight flex-1">
              “{TESTIMONIALS[0].text}”
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-4">
              <span className="h-12 w-12 rounded-full bg-brand-blue flex items-center justify-center font-bold text-lg">{TESTIMONIALS[0].name.charAt(0)}</span>
              <div>
                <p className="font-semibold">{TESTIMONIALS[0].name}</p>
                <p className="text-sm text-white/60">{TESTIMONIALS[0].area}</p>
              </div>
              <span className="ml-auto"><Stars /></span>
            </figcaption>
          </figure>
        </Reveal>

        {/* Supporting reviews */}
        <div className="lg:col-span-5 grid grid-cols-1 gap-6">
          {TESTIMONIALS.slice(1).map((t, i) => (
            <Reveal key={t.name} delay={0.1 + i * 0.08}>
              <figure className="h-full rounded-3xl bg-white border border-slate-100 shadow-[0_2px_10px_rgba(7,22,44,0.04)] p-7 flex flex-col hover:-translate-y-1 hover:shadow-[0_20px_40px_-15px_rgba(14,98,254,0.12)] transition-all duration-300" data-testid={`review-card-${i}`}>
                <Stars />
                <blockquote className="mt-4 text-brand-ink leading-relaxed flex-1">“{t.text}”</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="h-10 w-10 rounded-full bg-brand-ice text-brand-blue flex items-center justify-center font-bold">{t.name.charAt(0)}</span>
                  <div>
                    <p className="text-sm font-semibold text-brand-ink">{t.name}</p>
                    <p className="text-xs text-slate-500">{t.area}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Reviews;
